import { createSlice } from "@reduxjs/toolkit"
import { createAsyncThunk } from '@reduxjs/toolkit';
import { config } from "services/globalvariables/globalvariables";
// import { RootState } from '../store';
import axios from 'axios'
import { notifyAddTocart } from "components/userprofile/components/MyProfile";
//
//
interface fetchOTPState {
    data: [],
    loading: Boolean,
    isOTPVerified: Boolean,
    error: string,
    status: string | number | undefined;
}

const initialState: fetchOTPState = {
    data: [],
    loading: false,
    isOTPVerified: false,
    error: '',
    status: undefined
}

// --------------------------------------------------
// -----------------fetch--opt--thunk----------------
// --------------------------------------------------
//
//
export const fetchOTP: any = createAsyncThunk(
    'user/fetchOTP',
    async (number: string) => {
        //
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_HOST}partner/v1/otp-login/`,
                {
                    mobile_number: `${number}`,
                    key: "qwerty",
                },
                config

            );
            notifyAddTocart(response.data.message)
            return response.data
        } catch (err: any) {
            notifyAddTocart(err.response.data.message)
            throw Error(err.response.data.message)
        }
    }
)

const authFetchOTPSlice = createSlice({
    name: 'authOTP',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchOTP.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchOTP.fulfilled, (state, action) => {
                state.loading = false;
                state.data = []
                state.isOTPVerified = true
            })
            .addCase(fetchOTP.rejected, (state, action) => {
                state.loading = false;
                state.data = []
                state.error = action.error.message
            });
        //



    }

})
export default authFetchOTPSlice.reducer

